import type { FaireProductEntity } from "../../entity_types/product";

export const p_pgmpn3g22s: FaireProductEntity = {
  token: "p_pgmpn3g22s",
  type: "product",
  name: "Meadowland Incense Cones – Grass, Cedar & Patchouli | Clean Burning, 20-Pack",
  brandToken: "b_32d2mbpi",
  brandName: "Misc Goods Co.",
  imageUrl:
    "https://cdn.faire.com/fastly/8257332fd3c7254d498773e2048fde35dd4c527e3305c9b194364288d096f798.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/4d59035378df168ad7d2301cb08091bf8cfb7d4ce17fb9ebd27561400f4207fe.jpeg",
    "https://cdn.faire.com/fastly/27f733f6ab103655cb6f63f13fde9caf0b980fa0039c7aaef9c6d3ee98661c76.jpeg",
    "https://cdn.faire.com/fastly/d0fa1dc21248ec2ca1eee25a457b796a111ce0b57e3dc360c2636712df8580a0.jpeg",
  ],
  priceDollars: 10,
  description:
    "Rolling hills, dry grass, and deep breath. Meadowland Incense Cones bring the scent of sun-bleached hay, fresh mountain air, and earthy terrain into your space. With a blend of 13 essential oils, this fragrance is both grounded and expansive — inspired by landscapes shaped by weather, work, and time. Burn a cone to reconnect with the quiet of open land and bring a pastoral rhythm into your day.\n\n• Includes 20 incense cones per box\n• Burn time: 35+ minutes per cone\n• Fragrance notes: sun-dried hay, patchouli, cedar, leather, tobacco\n• Made with a blend of 13 essential oils\n• Clean-burning and free of synthetic additives\n• Ideal for home rituals, reflection, or everyday use\n• Crafted to evoke open fields and natural stillness\n• Made in the USA\n\nKeywords: Meadowland incense cones, earthy home fragrance, sun-dried grass scent, natural incense blend, field-inspired incense, clean burning cones, small batch incense, USA-made fragrance cones",
  tags: [],
  msrpDollars: 20,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-09-01T22:12:55.214Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
